import { ServiceRequestTransactionEsData } from 'src/app/core/models/shared/ServiceRequestTransactionEsData';
import { EsBaseServiceRequest } from '../../shared/EsBaseServiceRequest';

export class CitesBaseServiceRequest<
  TServiceTransaction
> extends EsBaseServiceRequest {
  serviceRequestTransactionData?: ServiceRequestTransactionEsData;
  serviceTransaction?: TServiceTransaction;
}
